import { Component } from '@angular/core';

@Component({
    selector: 'app-pagina404',
    imports: [],
    templateUrl: './pagina404.component.html',
})
export class Pagina404Component {}
